import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  OnInit,
} from '@angular/core';
import { IconRegistryService } from '@rd/core/services/icon-registry/icon-registry.service';
import { DialogRef } from '@rd/popup/dialog-ref';
import { SuccessButton } from '@rd/types';
import { RedeemCashSettingService } from '../../services/redeem-cash-setting/redeem-cash-setting.service';

@Component({
  selector: 'rd-rcv2-membership-success-dialog',
  templateUrl: './membership-success-dialog.component.html',
  styleUrls: ['./membership-success-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RcV2MembershipSuccessDialogComponent implements OnInit {
  @HostBinding('class.rd-rcv2-membership-success-dialog') componentClass = true;

  successLinkedDialogButton: SuccessButton;

  constructor(
    private dialogRef: DialogRef,
    private iconRegistryService: IconRegistryService,
    private redeemCashSettingService: RedeemCashSettingService,
  ) {}

  ngOnInit(): void {
    this.registerIcons();
    this.successLinkedDialogButton =
      this.redeemCashSettingService.successLinkedDialogButton;
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  private registerIcons(): void {
    this.iconRegistryService.registerIcon('linked');
  }
}
